import { render, staticRenderFns } from "./receivedEdit.vue?vue&type=template&id=3659e3d6&scoped=true"
import script from "./receivedEdit.vue?vue&type=script&lang=js"
export * from "./receivedEdit.vue?vue&type=script&lang=js"
import style0 from "./receivedEdit.vue?vue&type=style&index=0&id=3659e3d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3659e3d6",
  null
  
)

export default component.exports